import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import http from 'helpers/requests';

export const useFetchGuidingChecklists = (options = {}) => {
  return useQuery({
    queryKey: ['guidingChecklists'],
    queryFn: async () => {
      const res = await http.get('/guiding-checklists');
      return res.data.checklists;
    },
    staleTime: 0,
    refetchOnWindowFocus: 'always',
    ...options,
  });
};

export const useTickChecklistItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ checklistSlug, itemKey }) => {
      const res = await http.post('/guiding-checklists/tick', { checklistSlug, itemKey });
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['guidingChecklists']);
    },
  });
};

export const useDismissChecklist = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ checklistId }) => {
      const res = await http.post('/guiding-checklists/dismiss', { checklistId });
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['guidingChecklists']);
    },
  });
};
